import { Grid } from '@mui/material';
import CounterWithTable from './CounterWithTable';

const CounterWithTables = ({ title, upperTableData,lowerTableData,upperTableLabels,lowerTableLabels, Analytics }) => {
  return (
    <>
      <Grid container spacing={3} marginTop={3}>
        <CounterWithTable
          title={title}
          upperTableData={upperTableData}
          lowerTableData={lowerTableData}
          upperTableLabels={upperTableLabels}
          lowerTableLabels={lowerTableLabels}
          headerAnalyticsData={Analytics}
        />
      </Grid>
    </>
  );
};
export default CounterWithTables;
